/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ImageHelper } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";

import LinkWithLocale from "components/LinkWithLocale";
import { type IListComponentItemProps } from "../../models";

import styles from "./ListComponentItemCircle.module.scss";

export type ListComponentItemCircleProps = IListComponentItemProps;

export const ListComponentItemCircle = ({
  media,
}: ListComponentItemCircleProps) => {
  const circleImageUrl = ImageHelper.getCircleImageUrl(media?.Images);

  if (!media) {
    return <div className={styles.item} />;
  }

  return (
    <div className={styles.item}>
      <LinkWithLocale href={RouteHelper.goToDetails(media)}>
        <a>
          <img
            className={styles.image}
            src={circleImageUrl}
            alt={media?.Title}
          />
        </a>
      </LinkWithLocale>
    </div>
  );
};
